import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-system-maintenance',
  templateUrl: './system-maintenance.component.html',
})
export class SystemMaintenanceComponent implements OnInit {
  maintenanceModel: any;
  hideModalOnRoute = false;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

  hideModal() {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  resetHideModal(event): void {
    if (event) {
      this.closeModal.emit(true);
    }
  }
  refreshModal() {
    this.createMaintananceModel();
  }
  createMaintananceModel(): void {
    this.maintenanceModel = new ModalOptions({
      additionalClasses: 'modal-small modal-dialog center-on-page',
      onLoad: true,
      modalId: 'maitenance',
      modalTranslateCopy: 'System Down',
      size: 'modal-small',
      typeOfModal: 'default',
      modalName: 'system_maintenance',
    });
  }
  ngOnInit(): void {
    this.createMaintananceModel();
  }
}
